export default "__VITE_ASSET__784d4a46__"